<template>
  <div class="center">
    <div
      style="display: flex; justify-content: space-between"
      class="Previous-Next"
    >
      <div>
        <el-button size="small" @click="firstPage">首页</el-button>
        <el-button size="small" @click="prevPage">上一页</el-button>
        <el-button size="small" @click="nextPage">下一页</el-button>
        <el-button size="small" @click="lastPage">尾页</el-button>
        &nbsp; &nbsp;
        <span>Page: {{ pageNum }} / <span id="page_count"></span></span>
      </div>
      <!-- <el-button size="mini" icon="el-icon-download" @click="openPdf">下载</el-button> -->
    </div>
    <canvas id="the-canvas" />
  </div>
</template>

<script>
let pdfjsLib = window["pdfjs-dist/build/pdf"];
pdfjsLib.GlobalWorkerOptions.workerSrc = `/static/build/pdf.worker.js`;

export default {
  name: "pdfPreview",
  props: {
    pdfUrl: {
      type: String,
      default: "",
    },
    scale: {
      type: Number,
      default: 1,
    },
    page: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      pdfDoc: null,
      pageNum: 1,
      pageRendering: false,
      pageNumPending: null,
      canvas: null,
      ctx: null,
    };
  },
  methods: {
    renderPage(num) {
      let _this = this;
      this.pageRendering = true;
      // Using promise to fetch the page
      return this.pdfDoc.getPage(num).then((page) => {
        let viewport = page.getViewport({ scale: _this.scale });
        _this.canvas.height = viewport.height;
        _this.canvas.width = viewport.width;

        // Render PDF page into canvas context
        let renderContext = {
          canvasContext: _this.ctx,
          viewport: viewport,
        };
        let renderTask = page.render(renderContext);

        // Wait for rendering to finish
        renderTask.promise.then(() => {
          _this.pageRendering = false;
          if (_this.pageNumPending !== null) {
            // New page rendering is pending
            this.renderPage(_this.pageNumPending);
            _this.pageNumPending = null;
          }
        });
      });
    },
    queueRenderPage(num) {
      if (this.pageRendering) {
        this.pageNumPending = num;
      } else {
        this.renderPage(num);
      }
      this.$emit("pageChange", this.pageNum);
    },
    firstPage() {
      this.pageNum = 1;
      this.queueRenderPage(1);
    },
    lastPage() {
      this.pageNum = this.pdfDoc.numPages;
      this.queueRenderPage(this.pdfDoc.numPages);
    },
    prevPage() {
      if (this.pageNum <= 1) {
        return;
      }
      this.pageNum--;
      this.queueRenderPage(this.pageNum);
    },
    nextPage() {
      if (this.pageNum >= this.pdfDoc.numPages) {
        return;
      }
      this.pageNum++;
      this.queueRenderPage(this.pageNum);
    },
    openPdf() {
      window.open(this.pdfUrl);
    },
    init() {
      this.pageNum = this.page;

      this.canvas = document.getElementById("the-canvas");
      this.ctx = this.canvas.getContext("2d");
      console.log(this.canvas, "this.canvasthis.canvasthis.canvasthis.canvas");
      console.log(pdfjsLib);
      console.log("*****-----------****");

      pdfjsLib.getDocument(this.pdfUrl).promise.then((pdfDoc_) => {
        this.pdfDoc = pdfDoc_;
        document.getElementById("page_count").textContent =
          this.pdfDoc.numPages;
        this.renderPage(this.pageNum).then((res) => {
          this.$emit("renderPdf", {
            width: this.canvas.width,
            height: this.canvas.height,
          });
        });
      });
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    pdfUrl(val) {
      this.init();
    },
  },
};
</script>
<style scoped lang="scss">
.center {
  // display: flex;
  // justify-content: center;
  padding-bottom: 6px;
}
#the-canvas {
  position: absolute;
  user-select: none;
  top: 2.625rem;
  left: 0px;
  border: 0.0625rem solid #5ea6ef;
}
.Previous-Next {
  // position: absolute;
  user-select: none;
  // top: 2.625rem;
  right: 36%;
}
</style>